function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 40,
  fill: "#000",
  fillOpacity: 0.08
}), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#C9CAD3",
  d: "M58.788 16H21.212c-.67 0-1.212.543-1.212 1.212V63.88l.003.093c.08 1.161 1.64 1.558 2.252.525l3.565-6.018 3.11 5.96.048.085a1.212 1.212 0 0 0 2.052-.001l3.945-6.274 4.003 6.28.055.08c.501.667 1.53.64 1.99-.08l4.01-6.291 4.01 6.291.056.082c.53.703 1.632.623 2.044-.18l3.045-5.94 3.557 6.005c.628 1.06 2.255.615 2.255-.618V17.212c0-.67-.543-1.212-1.212-1.212z"
}), React.createElement("path", {
  fill: "#C9CAD3",
  d: "M57.576 18.424v41.03l-2.422-4.088-.053-.082a1.212 1.212 0 0 0-2.068.147l-3.083 6.013-3.896-6.112-.055-.08a1.212 1.212 0 0 0-1.989.08L40 61.623l-4.01-6.29-.056-.08a1.212 1.212 0 0 0-1.992.086l-3.84 6.106-3.14-6.017-.05-.087a1.212 1.212 0 0 0-2.067.03l-2.42 4.085V18.424h35.15z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M57.576 18.424v41.03l-2.422-4.088-.053-.082a1.212 1.212 0 0 0-2.068.147l-3.083 6.013-3.896-6.112-.055-.08a1.212 1.212 0 0 0-1.989.08L40 61.623l-4.01-6.29-.056-.08a1.212 1.212 0 0 0-1.992.086l-3.84 6.106-3.14-6.017-.05-.087a1.212 1.212 0 0 0-2.067.03l-2.42 4.085V18.424h35.15z"
})), React.createElement("path", {
  fill: "#C9CAD3",
  d: "M27.557 26.883H51.66a1.262 1.262 0 1 0 0-2.524H27.557a1.26 1.26 0 0 0-1.262 1.262 1.26 1.26 0 0 0 1.262 1.262zm0 7.639H51.66a1.263 1.263 0 1 0 0-2.526H27.557a1.262 1.262 0 0 0 0 2.526zm0 7.64H51.66a1.264 1.264 0 1 0 0-2.526H27.557a1.262 1.262 0 0 0 0 2.526zm0 7.638H51.66a1.262 1.262 0 1 0 0-2.524H27.557a1.26 1.26 0 0 0-1.262 1.262 1.26 1.26 0 0 0 1.262 1.262z"
}));

var SvgOrdersEmpty = function SvgOrdersEmpty(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: 80,
    height: 80
  }, props), React.createElement("title", null, title), _ref2);
};

export default SvgOrdersEmpty;